module.exports = __webpack_public_path__ + "static/img/clause_letter116.20ab95d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter116.png
// module id = uqQy
// module chunks = 1